import { App as AntdApp, ConfigProvider, type ThemeConfig } from 'antd';
import type { ReactNode } from 'react';
import { baseTheme } from './theme';

export interface AppThemeProviderProps {
  children: ReactNode;
  /** Optional theme overrides merged over the base tokens (e.g. brand color). */
  themeOverrides?: ThemeConfig;
  /** Text direction; 'rtl' for right-to-left locales (e.g. Arabic). */
  direction?: 'ltr' | 'rtl';
}

/**
 * Wraps the app with AntD's ConfigProvider (theme) and App (message/notification
 * context). Every admin surface renders inside this provider.
 */
export function AppThemeProvider({ children, themeOverrides, direction }: AppThemeProviderProps) {
  const theme: ThemeConfig = {
    ...baseTheme,
    ...themeOverrides,
    token: { ...baseTheme.token, ...themeOverrides?.token },
    components: { ...baseTheme.components, ...themeOverrides?.components },
  };

  return (
    <ConfigProvider theme={theme} direction={direction ?? 'ltr'}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
